export default {
     'Battle':'Battle',
     'Normal':'Normal',
}